'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_io$002eintela$002esites$002eintelacloud$002eui$002e$002dMarkdown$0024$002dBlock$0024$002dHeading from "./io.intela.sites.intelacloud.ui.-Markdown$-Block$-Heading.js";
import * as $j_io$002eintela$002esites$002eintelacloud$002eui$002e$002dMarkdown$0024$002dBlock$0024$002dItems from "./io.intela.sites.intelacloud.ui.-Markdown$-Block$-Items.js";
import * as $j_io$002eintela$002esites$002eintelacloud$002eui$002e$002dMarkdown$0024$002dBlock$0024$002dParagraph from "./io.intela.sites.intelacloud.ui.-Markdown$-Block$-Paragraph.js";
var $p;
function $p_Lio_intela_sites_intelacloud_ui_Markdown$__blocks__T__sci_List($thiz, source) {
  var lines = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$().aR(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sc_StringOps$$anon$1($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__replaceAll__T__T__T(source, "(?s)<!--.*?-->", ""), true));
  var z = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
  var acc = z;
  var these = lines;
  while ((!these.g())) {
    var arg1 = acc;
    var arg2 = these.k();
    matchResult11: {
      if (($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__trim__T(arg2) === "")) {
        acc = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$(), arg1);
        break matchResult11;
      }
      if ((arg1 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon)) {
        var x37 = arg1.fz;
        var x38 = arg1.E;
        if ($p_Lio_intela_sites_intelacloud_ui_Markdown$__startsNew__T__sci_List__Z($m_Lio_intela_sites_intelacloud_ui_Markdown$(), arg2, x37)) {
          acc = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(arg2, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(x37, x38));
          break matchResult11;
        }
        acc = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(arg2, x37), x38);
        break matchResult11;
      }
      if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$().f(arg1)) {
        acc = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(arg2, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
        break matchResult11;
      }
      throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(arg1);
    }
    these = these.i();
  }
  var this$9 = acc;
  var f = ((_$1) => _$1.o1());
  if ((this$9 === $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())) {
    var this$10 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
  } else {
    var arg1$1 = this$9.k();
    var h = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(f(arg1$1), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    var t = h;
    var rest = this$9.i();
    while ((rest !== $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())) {
      var arg1$2 = rest.k();
      var nx = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(f(arg1$2), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
      t.E = nx;
      t = nx;
      rest = rest.i();
    }
    var this$10 = h;
  }
  var f$1 = ((_$2) => (!_$2.g()));
  var l = this$10;
  block: {
    var $x_1;
    while (true) {
      if (l.g()) {
        var $x_1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
        break;
      } else {
        var h$1 = l.k();
        var t$1 = l.i();
        if (((!(!f$1(h$1))) === false)) {
          l = t$1;
          continue;
        }
        var start = l;
        var remaining = t$1;
        while (true) {
          if (remaining.g()) {
            var $x_1 = start;
            break block;
          } else {
            var x$2 = remaining.k();
            if (((!(!f$1(x$2))) !== false)) {
              remaining = remaining.i();
              continue;
            }
            var firstMiss = remaining;
            var newHead = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(start.k(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
            var toProcess = start.i();
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(toProcess.k(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
              currentLast.E = newElem;
              currentLast = newElem;
              toProcess = toProcess.i();
            }
            var next = firstMiss.i();
            var nextToCopy = next;
            while ((!next.g())) {
              var head = next.k();
              if (((!(!f$1(head))) !== false)) {
                next = next.i();
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(nextToCopy.k(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
                  currentLast.E = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = nextToCopy.i();
                }
                nextToCopy = next.i();
                next = next.i();
              }
            }
            if ((!nextToCopy.g())) {
              currentLast.E = nextToCopy;
            }
            var $x_1 = newHead;
            break block;
          }
        }
      }
    }
  }
  var this$11 = $x_1.o1();
  var f$2 = ((lines$2) => $p_Lio_intela_sites_intelacloud_ui_Markdown$__toBlock__sci_List__Lio_intela_sites_intelacloud_ui_Markdown$Block($m_Lio_intela_sites_intelacloud_ui_Markdown$(), lines$2));
  if ((this$11 === $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())) {
    return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
  } else {
    var arg1$3 = this$11.k();
    var h$2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(f$2(arg1$3), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    var t$2 = h$2;
    var rest$1 = this$11.i();
    while ((rest$1 !== $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())) {
      var arg1$4 = rest$1.k();
      var nx$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(f$2(arg1$4), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
      t$2.E = nx$1;
      t$2 = nx$1;
      rest$1 = rest$1.i();
    }
    return h$2;
  }
}
export { $p_Lio_intela_sites_intelacloud_ui_Markdown$__blocks__T__sci_List as $p_Lio_intela_sites_intelacloud_ui_Markdown$__blocks__T__sci_List };
function $p_Lio_intela_sites_intelacloud_ui_Markdown$__startsNew__T__sci_List__Z($thiz, line, current) {
  var this$1 = current.nC();
  if ((!this$1.g())) {
    var arg1 = this$1.L();
    return ((($m_Lio_intela_sites_intelacloud_ui_Markdown$(), (!(!line.startsWith("#")))) || ($m_Lio_intela_sites_intelacloud_ui_Markdown$(), (!(!arg1.startsWith("#"))))) || (($m_Lio_intela_sites_intelacloud_ui_Markdown$(), (!(!line.startsWith("- ")))) !== ($m_Lio_intela_sites_intelacloud_ui_Markdown$(), (!(!arg1.startsWith("- "))))));
  } else {
    return false;
  }
}
export { $p_Lio_intela_sites_intelacloud_ui_Markdown$__startsNew__T__sci_List__Z as $p_Lio_intela_sites_intelacloud_ui_Markdown$__startsNew__T__sci_List__Z };
function $p_Lio_intela_sites_intelacloud_ui_Markdown$__toBlock__sci_List__Lio_intela_sites_intelacloud_ui_Markdown$Block($thiz, lines) {
  var this$1 = lines.nC();
  var first = (this$1.g() ? "" : this$1.L());
  if ((!(!first.startsWith("#")))) {
    _return: {
      var len = first.length;
      var i = 0;
      while ((i < len)) {
        if ((first.charCodeAt(i) !== 35)) {
          var x1 = i;
          break _return;
        }
        i = ((1 + i) | 0);
      }
      var x1 = (-1);
    }
    var this$5 = ((x1 === (-1)) ? first : first.substring(0, x1));
    var level = this$5.length;
    return new $j_io$002eintela$002esites$002eintelacloud$002eui$002e$002dMarkdown$0024$002dBlock$0024$002dHeading.$c_Lio_intela_sites_intelacloud_ui_Markdown$Block$Heading(level, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__trim__T($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sc_StringOps$().nk(first, level)));
  } else if ((!(!first.startsWith("- ")))) {
    var f = ((_$4) => $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__trim__T($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sc_StringOps$().nk(_$4, 2)));
    if ((lines === $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())) {
      var $x_1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    } else {
      var arg1$1 = lines.k();
      var h = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(f(arg1$1), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
      var t = h;
      var rest = lines.i();
      while ((rest !== $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())) {
        var arg1$2 = rest.k();
        var nx = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(f(arg1$2), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
        t.E = nx;
        t = nx;
        rest = rest.i();
      }
      var $x_1 = h;
    }
    return new $j_io$002eintela$002esites$002eintelacloud$002eui$002e$002dMarkdown$0024$002dBlock$0024$002dItems.$c_Lio_intela_sites_intelacloud_ui_Markdown$Block$Items($x_1);
  } else {
    var f$1 = ((_$5) => $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__trim__T(_$5));
    if ((lines === $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())) {
      var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    } else {
      var arg1$3 = lines.k();
      var h$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(f$1(arg1$3), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
      var t$1 = h$1;
      var rest$1 = lines.i();
      while ((rest$1 !== $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())) {
        var arg1$4 = rest$1.k();
        var nx$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(f$1(arg1$4), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
        t$1.E = nx$1;
        t$1 = nx$1;
        rest$1 = rest$1.i();
      }
      var $x_2 = h$1;
    }
    return new $j_io$002eintela$002esites$002eintelacloud$002eui$002e$002dMarkdown$0024$002dBlock$0024$002dParagraph.$c_Lio_intela_sites_intelacloud_ui_Markdown$Block$Paragraph($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_IterableOnceOps__mkString__T__T__T__T($x_2, "", " ", ""));
  }
}
export { $p_Lio_intela_sites_intelacloud_ui_Markdown$__toBlock__sci_List__Lio_intela_sites_intelacloud_ui_Markdown$Block as $p_Lio_intela_sites_intelacloud_ui_Markdown$__toBlock__sci_List__Lio_intela_sites_intelacloud_ui_Markdown$Block };
function $p_Lio_intela_sites_intelacloud_ui_Markdown$__spans__T__sci_List($thiz, text) {
  matchResult14: {
    var \u03b41$___1;
    var \u03b41$___2;
    var this$10 = $thiz.rJ.xw(text);
    var z = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$(), 0);
    var f = ((x$1, x$2) => {
      var x50 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2(x$1, x$2);
      var x51 = x50.kl;
      if ((x51 !== null)) {
        var acc = x51.aX();
        var from = (x51.aQ() | 0);
        var m = x50.km;
        var $x_1 = $m_Lio_intela_sites_intelacloud_ui_Markdown$();
        var endIndex = m.mV;
        var before = $p_Lio_intela_sites_intelacloud_ui_Markdown$__textNode__T__Lcom_raquo_laminar_modifiers_Modifier($x_1, text.substring(from, endIndex));
        matchResult12: {
          var $x_2;
          var x39 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().cE($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_util_matching_Regex$MatchData__group__I__T(m, 1)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().cE($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_util_matching_Regex$MatchData__group__I__T(m, 3)));
          var x46 = x39.kl;
          var x47 = x39.km;
          if ((x46 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some)) {
            var label = x46.ce;
            var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().b.kE().d($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().c(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().b.kP().y($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_util_matching_Regex$MatchData__group__I__T(m, 2)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().b.j.h("link link-primary"), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().b, label, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$().x)])));
            break matchResult12;
          }
          if (($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$() === x46)) {
            if ((x47 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some)) {
              var bold = x47.ce;
              var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().b.ct().d($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().c(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().b, bold, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$().x)])));
              break matchResult12;
            }
            if (($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$() === x47)) {
              var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().b.wP().d($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().c(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().b, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_util_matching_Regex$MatchData__group__I__T(m, 4), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$().x)])));
              break matchResult12;
            }
          }
          throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(x39);
        }
        return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($x_2, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(before, acc)), m.mT);
      }
      throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(x50);
    });
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$is_sc_IndexedSeq(this$10)) {
      var at = 0;
      var end = this$10.C();
      var acc$1 = z;
      var $x_3;
      while (true) {
        if ((at !== end)) {
          var temp$at = ((1 + at) | 0);
          var arg1 = acc$1;
          var arg2 = this$10.J(at);
          var temp$acc = f(arg1, arg2);
          at = temp$at;
          acc$1 = temp$acc;
          continue;
        }
        var $x_3 = acc$1;
        break;
      }
    } else {
      var result = z;
      while (this$10.u()) {
        var arg1$1 = result;
        var arg2$1 = this$10.o();
        result = f(arg1$1, arg2$1);
      }
      var $x_3 = result;
    }
    var x55 = $x_3;
    if ((x55 !== null)) {
      var \u03b41$___1 = x55.aX();
      var \u03b41$___2 = (x55.aQ() | 0);
      break matchResult14;
    }
    throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(x55);
  }
  var nodes$2 = \u03b41$___1;
  var end$2 = (\u03b41$___2 | 0);
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($p_Lio_intela_sites_intelacloud_ui_Markdown$__textNode__T__Lcom_raquo_laminar_modifiers_Modifier($thiz, text.substring(end$2)), nodes$2).o1();
}
export { $p_Lio_intela_sites_intelacloud_ui_Markdown$__spans__T__sci_List as $p_Lio_intela_sites_intelacloud_ui_Markdown$__spans__T__sci_List };
function $p_Lio_intela_sites_intelacloud_ui_Markdown$__textNode__T__Lcom_raquo_laminar_modifiers_Modifier($thiz, text) {
  return ((text === "") ? $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().b.pW : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_nodes_TextNode(text));
}
export { $p_Lio_intela_sites_intelacloud_ui_Markdown$__textNode__T__Lcom_raquo_laminar_modifiers_Modifier as $p_Lio_intela_sites_intelacloud_ui_Markdown$__textNode__T__Lcom_raquo_laminar_modifiers_Modifier };
/** @constructor */
function $c_Lio_intela_sites_intelacloud_ui_Markdown$() {
  this.rJ = null;
  $n_Lio_intela_sites_intelacloud_ui_Markdown$ = this;
  this.rJ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_s_util_matching_Regex__T__sci_Seq__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_matching_Regex(), "\\[([^\\]]+)\\]\\(([^)\\s]+)\\)|\\*\\*([^*]+)\\*\\*|`([^`]+)`", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
}
export { $c_Lio_intela_sites_intelacloud_ui_Markdown$ as $c_Lio_intela_sites_intelacloud_ui_Markdown$ };
$p = $c_Lio_intela_sites_intelacloud_ui_Markdown$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_ui_Markdown$;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_ui_Markdown$() {
}
export { $h_Lio_intela_sites_intelacloud_ui_Markdown$ as $h_Lio_intela_sites_intelacloud_ui_Markdown$ };
$h_Lio_intela_sites_intelacloud_ui_Markdown$.prototype = $p;
$p.ze = (function(source) {
  var this$20 = $p_Lio_intela_sites_intelacloud_ui_Markdown$__blocks__T__sci_List(this, source);
  var f$1 = ((x$1) => {
    if ((x$1 instanceof $j_io$002eintela$002esites$002eintelacloud$002eui$002e$002dMarkdown$0024$002dBlock$0024$002dHeading.$c_Lio_intela_sites_intelacloud_ui_Markdown$Block$Heading)) {
      var x30 = x$1.fi;
      var x31 = x$1.fj;
      if ((x30 === 1)) {
        return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().b.nz().d($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().c(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().b, $p_Lio_intela_sites_intelacloud_ui_Markdown$__spans__T__sci_List($m_Lio_intela_sites_intelacloud_ui_Markdown$(), x31), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_$less$colon$less$().bz, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
      }
      if ((x30 === 2)) {
        return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().b.uc().d($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().c(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().b.j.h("mt-6"), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().b, $p_Lio_intela_sites_intelacloud_ui_Markdown$__spans__T__sci_List($m_Lio_intela_sites_intelacloud_ui_Markdown$(), x31), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_$less$colon$less$().bz, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
      }
      return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().b.ds().d($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().c(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().b.j.h("mt-4"), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().b, $p_Lio_intela_sites_intelacloud_ui_Markdown$__spans__T__sci_List($m_Lio_intela_sites_intelacloud_ui_Markdown$(), x31), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_$less$colon$less$().bz, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
    }
    if ((x$1 instanceof $j_io$002eintela$002esites$002eintelacloud$002eui$002e$002dMarkdown$0024$002dBlock$0024$002dParagraph.$c_Lio_intela_sites_intelacloud_ui_Markdown$Block$Paragraph)) {
      var x19 = x$1.ih;
      return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().b.b7().d($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().c(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().b, $p_Lio_intela_sites_intelacloud_ui_Markdown$__spans__T__sci_List($m_Lio_intela_sites_intelacloud_ui_Markdown$(), x19), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_$less$colon$less$().bz, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
    }
    if ((x$1 instanceof $j_io$002eintela$002esites$002eintelacloud$002eui$002e$002dMarkdown$0024$002dBlock$0024$002dItems.$c_Lio_intela_sites_intelacloud_ui_Markdown$Block$Items)) {
      var x16 = x$1.ig;
      var $x_5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().b.bW();
      var $x_4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$();
      var $x_3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().b.j.h("list-disc space-y-1 pl-6");
      var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().b;
      var f = ((item) => $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().b.br().d($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().c(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().b, $p_Lio_intela_sites_intelacloud_ui_Markdown$__spans__T__sci_List($m_Lio_intela_sites_intelacloud_ui_Markdown$(), item), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_$less$colon$less$().bz, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())]))));
      if ((x16 === $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())) {
        var $x_1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
      } else {
        var arg1 = x16.k();
        var h = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(f(arg1), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
        var t = h;
        var rest = x16.i();
        while ((rest !== $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())) {
          var arg1$1 = rest.k();
          var nx = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(f(arg1$1), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
          t.E = nx;
          t = nx;
          rest = rest.i();
        }
        var $x_1 = h;
      }
      return $x_5.d($x_4.c(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_3, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($x_2, $x_1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
    }
    throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(x$1);
  });
  if ((this$20 === $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())) {
    return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
  } else {
    var arg1$2 = this$20.k();
    var h$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(f$1(arg1$2), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    var t$1 = h$1;
    var rest$1 = this$20.i();
    while ((rest$1 !== $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())) {
      var arg1$3 = rest$1.k();
      var nx$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(f$1(arg1$3), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
      t$1.E = nx$1;
      t$1 = nx$1;
      rest$1 = rest$1.i();
    }
    return h$1;
  }
});
var $d_Lio_intela_sites_intelacloud_ui_Markdown$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_ui_Markdown$, "io.intela.sites.intelacloud.ui.Markdown$", ({
  f2: 1
}));
export { $d_Lio_intela_sites_intelacloud_ui_Markdown$ as $d_Lio_intela_sites_intelacloud_ui_Markdown$ };
var $n_Lio_intela_sites_intelacloud_ui_Markdown$;
function $m_Lio_intela_sites_intelacloud_ui_Markdown$() {
  if ((!$n_Lio_intela_sites_intelacloud_ui_Markdown$)) {
    $n_Lio_intela_sites_intelacloud_ui_Markdown$ = new $c_Lio_intela_sites_intelacloud_ui_Markdown$();
  }
  return $n_Lio_intela_sites_intelacloud_ui_Markdown$;
}
export { $m_Lio_intela_sites_intelacloud_ui_Markdown$ as $m_Lio_intela_sites_intelacloud_ui_Markdown$ };
//# sourceMappingURL=io.intela.sites.intelacloud.ui.-Markdown$.js.map
